(function () {
  function initWordmark() {
    document.querySelectorAll("[data-bl-o]").forEach(function (o) {
      if (o.dataset.blInit) return; o.dataset.blInit = "1";
      var syms = o.querySelectorAll("svg"); if (!syms.length) return;
      if (!o.querySelector("svg.is-active")) syms[0].classList.add("is-active");
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      var i = 0;
      setInterval(function () {
        var prev = i; syms[prev].classList.remove("is-active"); syms[prev].classList.add("is-exit");
        i = (i + 1) % syms.length;
        setTimeout(function () { syms[prev].classList.remove("is-exit"); }, 360);
        syms[i].classList.add("is-active");
      }, 1100);
    });
  }
  function initReveal() {
    if (!("IntersectionObserver" in window)) { document.querySelectorAll(".bl-reveal").forEach(function (el) { el.classList.add("is-in"); }); return; }
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); obs.unobserve(e.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll(".bl-reveal").forEach(function (el) { obs.observe(el); });
  }
  function initCopy() {
    document.querySelectorAll("[data-bl-copy]").forEach(function (b) {
      if (b.dataset.blInit) return; b.dataset.blInit = "1";
      b.addEventListener("click", function () {
        var t = b.getAttribute("data-bl-copy");
        var done = function () { var o = b.textContent; b.textContent = "Copied!"; setTimeout(function () { b.textContent = o; }, 2000); };
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(t).then(done).catch(done); }
        else { var i = document.createElement("input"); i.value = t; document.body.appendChild(i); i.select(); try { document.execCommand("copy"); } catch (e) {} document.body.removeChild(i); done(); }
      });
    });
  }
  function initBurger() {
    document.querySelectorAll("[data-bl-burger]").forEach(function (b) {
      if (b.dataset.blInit) return; b.dataset.blInit = "1";
      b.addEventListener("click", function () {
        var m = document.querySelector("[data-bl-mobile]"); if (!m) return;
        m.hidden = !m.hidden;
        b.classList.toggle("is-open", !m.hidden);
        b.setAttribute("aria-expanded", String(!m.hidden));
        // The drawer is cream; a transparent overlay header behind it would leave
        // the links floating over the hero video.
        var h = b.closest(".bl-header");
        if (h) h.classList.toggle("is-open", !m.hidden);
      });
    });
  }
  function init() { initWordmark(); initReveal(); initCopy(); initBurger(); }
  if (document.readyState !== "loading") init(); else document.addEventListener("DOMContentLoaded", init);
})();
